import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',    // 首页
        component: () => import('../views/Login/Login.vue')
    },
    // {
    //     path: '/index',
    //     name: 'index',
    //     component: () => import('../views/Index/index.vue')
    // },
    {
        path: '/dataCenterScreen',   // 互联网数据中心
        name: 'dataCenterScreen',
        component: () => import('../views/dataCenterScreen/dataCenterScreen.vue')  // 互联网数据中心
    }, {
        path: '/tourismPublicOpiniocScreen', //舆情监测
        name: 'tourismPublicOpiniocScreen',
        component: () => import('../views/tourismPublicOpiniocScreen/tourismPublicOpiniocScreen.vue')
    }, {
        path: '/UserPortrait',            // 用户画像
        name: 'UserPortrait',
        component: () => import('../views/UserPortrait/UserPortrait.vue')
    }, {
        path: '/propagationAnalysis',   //传播分析
        name: 'propagationAnalysis',
        component: () => import('../views/propagationAnalysis/propagation.vue')
    }, {
        path: '/touristSatisfaction',  // 游客满意
        name: 'touristSatisfaction',
        component: () => import('../views/touristSatisfaction/touristSatisfaction.vue')
    }, {
        path: '/brandEvaluation',   // 品牌评估
        name: 'brandEvaluation',
        component: () => import('../views/brandEvaluation/brandEvaluation.vue')
    }, {
        path: '/passengerFlowTrend',  // 客流趋势
        name: 'passengerFlowTrend',
        component: () => import('../views/passengerFlowTrend/passengerFlowTrend.vue')
    }, {
        path: '/passengerFlow',   // 实时客流
        name: 'passengerFlow',
        component: () => import('../views/passengerFlow/passengerFlow.vue')
    }, {
        path: '/travelRelatedConsumption',   //涉旅消费
        name: 'travelRelatedConsumption',
        component: () => import('../views/travelRelatedConsumption/travelRelatedConsumption.vue')
    },
    // {
    //     path: '/visitorSpending',
    //     name: 'visitorSpending',
    //     component: () => import('../views/visitorSpending/visitorSpending.vue')
    // },
    {
        path: '/passengerFlowDistribution',    // 客流分布
        name: 'passengerFlowDistribution',
        component:() =>import('../views/passengerFlowDistribution/passengerFlowDistribution.vue')
    }
]
const router = new VueRouter({
    routes
})

export default router
